import {
  Col,
  Form,
  Row,
  Modal,
  Button,
  Image
} from 'react-bootstrap';

import styles from './Vestuario.module.css';
import tabelaDeMedidas from '../../assets/img/tabela-de-medidas.png';

const Vestuario = props => {
  return (
    <>
      <Row className={styles.title}>Vestuário</Row>
      <div className={styles.tabelaContainer}>
        <Image
          width={400}
          height={235}
          src={tabelaDeMedidas}
          fluid
          className={styles.tabela}
        />
      </div>

      {!props.isVestuario ? (
        <>
          <Row>
            <Col sm={12}>
              <Form.Group controlId="camisa" className="mt-4">
                <Form.Label className={styles.confirm}>*CAMISA:</Form.Label>
                <Form.Check
                  value="P"
                  checked={props.camisa === 'P'}
                  className={styles.radio}
                  inline
                  label="P"
                  name="camisa"
                  type="radio"
                  id="camisa-P"
                  onChange={e => props.handleCamisa(e)}
                />
                <Form.Check
                  value="M"
                  checked={props.camisa === 'M'}
                  className={styles.radio}
                  inline
                  label="M"
                  name="camisa"
                  type="radio"
                  id="camisa-M"
                  onChange={e => props.handleCamisa(e)}
                />
                <Form.Check
                  value="G"
                  checked={props.camisa === 'G'}
                  className={styles.radio}
                  inline
                  name="camisa"
                  label="G"
                  type="radio"
                  id="camisa-G"
                  onChange={e => props.handleCamisa(e)}
                />
                <Form.Check
                  value="GG"
                  checked={props.camisa === 'GG'}
                  className={styles.radio}
                  inline
                  name="camisa"
                  label="GG"
                  type="radio"
                  id="camisa-GG"
                  onChange={e => props.handleCamisa(e)}
                />
                <Form.Check
                  value="XXG"
                  checked={props.camisa === 'XXG'}
                  className={styles.radio}
                  inline
                  name="camisa"
                  label="XXG"
                  type="radio"
                  id="camisa-XXG"
                  onChange={e => props.handleCamisa(e)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <Form.Group controlId="calca" className="mt-4">
                <Form.Label className={styles.confirm}>*CALÇA:&nbsp;&nbsp;</Form.Label>
                <Form.Check
                  value="P"
                  checked={props.calca === 'P'}
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  label="P"
                  name="calca"
                  type="radio"
                  id="calca-P"
                />
                <Form.Check
                  value="M"
                  checked={props.calca === 'M'}
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  label="M"
                  name="calca"
                  type="radio"
                  id="calca-M"
                />
                <Form.Check
                  value="G"
                  checked={props.calca === 'G'}
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  name="calca"
                  label="G"
                  type="radio"
                  id="calca-G"
                />
                <Form.Check
                  value="GG"
                  checked={props.calca === 'GG'}
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  name="calca"
                  label="GG"
                  type="radio"
                  id="calca-GG"
                />
                <Form.Check
                  value="XXG"
                  checked={props.calca === 'XXG'}
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  name="calca"
                  label="XXG"
                  type="radio"
                  id="calca-XXG"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <Form.Group controlId="jaleco" className="mt-4">
                <Form.Label className={styles.confirm}>*JALECO:</Form.Label>
                <Form.Check
                  value="P"
                  checked={props.jaleco === 'P'}
                  onChange={e => props.handleJaleco(e)}
                  className={styles.radio}
                  inline
                  label="P"
                  name="jaleco"
                  type="radio"
                  id="jaleco-P"
                />
                <Form.Check
                  value="M"
                  checked={props.jaleco === 'M'}
                  onChange={e => props.handleJaleco(e)}
                  className={styles.radio}
                  inline
                  label="M"
                  name="jaleco"
                  type="radio"
                  id="jaleco-M"
                />
                <Form.Check
                  value="G"
                  checked={props.jaleco === 'G'}
                  onChange={e => props.handleJaleco(e)}
                  className={styles.radio}
                  inline
                  name="jaleco"
                  label="G"
                  type="radio"
                  id="jaleco-G"
                />
                <Form.Check
                  value="GG"
                  checked={props.jaleco === 'GG'}
                  onChange={e => props.handleJaleco(e)}
                  className={styles.radio}
                  inline
                  name="jaleco"
                  label="GG"
                  type="radio"
                  id="jaleco-GG"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <Form.Group controlId="calcado" className="mt-4">
                <Form.Label className={styles.confirm}>*CALÇADO:</Form.Label>
                <Form.Select
                  className="border border-secondary"
                  required
                  name="calcado"
                  onChange={e => props.handleCalcado(e)}
                  value={props.calcado}
                >
                  <option value="">Selecione o número do calçado:</option>
                  {props.numeroCalcado.map(numero => (
                    <option key={numero} value={numero}>{numero}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <Form.Group controlId="observacoes" className="mt-4">
                <Form.Label className={styles.confirm}>OBSERVAÇÕES:</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="5"
                  className="border border-secondary"
                  name="observacoes"
                  onChange={e => props.handleVestuarioObservacoes(e)}
                  value={props.vestuarioObservacoes}
                />
              </Form.Group>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col sm={12}>
              <Form.Group controlId="camisa" className="mt-4">
                <Form.Label className={styles.confirm}>*CAMISA:</Form.Label>
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.camisa === 'P'}
                  value="P"
                  className={styles.radio}
                  inline
                  label="P"
                  name="camisa"
                  type="radio"
                  id="camisa-P"
                  onChange={e => props.handleCamisa(e)}
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.camisa === 'M'}
                  value="M"
                  className={styles.radio}
                  inline
                  label="M"
                  name="camisa"
                  type="radio"
                  id="camisa-M"
                  onChange={e => props.handleCamisa(e)}
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.camisa === 'G'}
                  value="G"
                  className={styles.radio}
                  inline
                  name="camisa"
                  label="G"
                  type="radio"
                  id="camisa-G"
                  onChange={e => props.handleCamisa(e)}
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.camisa === 'GG'}
                  value="GG"
                  className={styles.radio}
                  inline
                  name="camisa"
                  label="GG"
                  type="radio"
                  id="camisa-GG"
                  onChange={e => props.handleCamisa(e)}
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.camisa === 'XXG'}
                  value="XXG"
                  className={styles.radio}
                  inline
                  name="camisa"
                  label="XXG"
                  type="radio"
                  id="camisa-XXG"
                  onChange={e => props.handleCamisa(e)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <Form.Group controlId="calca" className="mt-4">
                <Form.Label className={styles.confirm}>*CALÇA:&nbsp;&nbsp;</Form.Label>
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.calca === 'P'}
                  value="P"
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  label="P"
                  name="calca"
                  type="radio"
                  id="calca-P"
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.calca === 'M'}
                  value="M"
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  label="M"
                  name="calca"
                  type="radio"
                  id="calca-M"
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.calca === 'G'}
                  value="G"
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  name="calca"
                  label="G"
                  type="radio"
                  id="calca-G"
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.calca === 'GG'}
                  value="GG"
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  name="calca"
                  label="GG"
                  type="radio"
                  id="calca-GG"
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.calca === 'XXG'}
                  value="XXG"
                  onChange={e => props.handleCalca(e)}
                  className={styles.radio}
                  inline
                  name="calca"
                  label="XXG"
                  type="radio"
                  id="calca-XXG"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <Form.Group controlId="jaleco" className="mt-4">
                <Form.Label className={styles.confirm}>*JALECO:</Form.Label>
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.jaleco === 'P'}
                  value="P"
                  onChange={e => props.handleJaleco(e)}
                  className={styles.radio}
                  inline
                  label="P"
                  name="jaleco"
                  type="radio"
                  id="jaleco-P"
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.jaleco === 'M'}
                  value="M"
                  onChange={e => props.handleJaleco(e)}
                  className={styles.radio}
                  inline
                  label="M"
                  name="jaleco"
                  type="radio"
                  id="jaleco-M"
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.jaleco === 'G'}
                  value="G"
                  onChange={e => props.handleJaleco(e)}
                  className={styles.radio}
                  inline
                  name="jaleco"
                  label="G"
                  type="radio"
                  id="jaleco-G"
                />
                <Form.Check
                  disabled
                  checked={props?.isVestuario?.jaleco === 'GG'}
                  value="GG"
                  onChange={e => props.handleJaleco(e)}
                  className={styles.radio}
                  inline
                  name="jaleco"
                  label="GG"
                  type="radio"
                  id="jaleco-GG"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <Form.Group controlId="calcado" className="mt-4">
                <Form.Label className={styles.confirm}>*CALÇADO:</Form.Label>
                <Form.Select
                  disabled
                  className="border border-secondary"
                  required
                  name="calcado"
                  onChange={e => props.handleCalcado(e)}
                  value={props.calcado}
                >
                  <option defaultValue={props?.isVestuario?.calcado}>{props?.isVestuario?.calcado}</option>
                  {props.numeroCalcado.map(numero => (
                    <option key={numero} value={numero}>{numero}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <Form.Group controlId="observacoes" className="mt-4 mb-4">
                <Form.Label className={styles.confirm}>OBSERVAÇÕES:</Form.Label>
                <Form.Control
                  readOnly
                  as="textarea"
                  rows="5"
                  className="border border-secondary"
                  name="observacoes"
                  onChange={e => props.handleVestuarioObservacoes(e)}
                  value={props?.isVestuario?.observacoes}
                />
              </Form.Group>
            </Col>
          </Row>
        </>
      )}

      <Modal show={props.showVestuarioModal} onHide={props.handleVestuarioModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.vestuarioError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleVestuarioModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={props.showVestuarioMessageModal} onHide={props.handleVestuarioMessageModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>O vestuário será disponibilizado de acordo com a categoria profissional.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleVestuarioMessageModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        contentClassName={styles.modalWidth}
        show={props.showModalVestuarioConfirm}
        onHide={props.handleModalVestuarioConfirmClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Você selecionou as opções:</p>
          <p className={styles.confirm}>CAMISA: {props.camisa}</p>
          <p className={styles.confirm}>CALÇA: {props.calca}</p>
          <p className={styles.confirm}>JALECO: {props.jaleco}</p>
          <p className={styles.confirm}>CALÇADO: {props.calcado}</p>
          {props.vestuarioObservacoes !== '' && (
            <p className={styles.confirm}>OBSERVAÇÕES: {props.vestuarioObservacoes}</p>
          )}
          <p>Após confirmar a sua opção não será possível alterá-la.</p>
          <p className={styles.confirm}>Deseja confirmar?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleModalVestuarioConfirmClose}>
            Não
          </Button>
          <Button variant="flat" className={styles.btn} onClick={props.vestuarioConfirm}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Vestuario;
